export const SET_MADE_RESERVATIONS = 'SET_MADE_RESERVATIONS';
export const SET_RECEIVED_RESERVATIONS = 'SET_RECEIVED_RESERVATIONS';